import { FormattedMessage } from 'react-intl'

/**
 * returns ["24 hours","00:00","00:30",…,"23:30", "23:59"]
 */
export const generateTimeOptions = () => {
  const slots = ['24 hours']
  // half-hour increments
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const hh = String(h).padStart(2, '0')
      const mm = String(m).padStart(2, '0')
      slots.push(`${hh}:${mm}`)
    }
  }
  // ensure 23:59 is the very last option
  slots.push('23:59')
  return slots
}

export const raws = (initial) => {
  return initial.map((d) => ({
    ...d,
    openTime: typeof d.openTime === 'string' ? d.openTime.toLowerCase() : null,
    closeTime:
      typeof d.closeTime === 'string' ? d.closeTime.toLowerCase() : null,
  }))
}

export const renderLabel = ({ checked, openTime, closeTime, isInitial }) => {
  if (isInitial) return '--'
  if (checked === 0) return <FormattedMessage id="label.closed" />
  if (openTime === '24 hours')
    return <FormattedMessage id="manageChannels.selectorTime.allDay.lable" />
  return `${openTime} – ${closeTime}`
}

export const openHours = {
  CLOSE_HOURS: 0,
  OPEN_HOURS: 1,
  TIME_START_DAY: '00:00',
  TIME_END_DAY: '23:59',
  TIME_START: '10:00',
  TIME_END: '20:30',
  ALL_DAY: '24 hours',
}

export const allDay = (openTime, closeTime) => {
  return openTime === openHours.ALL_DAY || closeTime === openHours.ALL_DAY
}

export const handleInitialValues = (initial = []) => {
  return {
    data: initial.map((d) => ({
      ...d,
      openTime:
        d.checked === openHours.OPEN_HOURS
          ? d.openTime
          : openHours.TIME_START_DAY || openHours.TIME_START,
      closeTime:
        d.checked === openHours.OPEN_HOURS
          ? d.closeTime
          : openHours.TIME_END_DAY || openHours.TIME_END,
    })),
  }
}

const labelIds = {
  monday: 'weekday.monday',
  tuesday: 'weekday.tuesday',
  wednesday: 'weekday.wednesday',
  thursday: 'weekday.thursday',
  friday: 'weekday.friday',
  saturday: 'weekday.saturday',
  sunday: 'weekday.sunday',
}

export const getLabelId = (openDay) => {
  return labelIds[openDay]
}

export const defaultData = [
  {
    openDay: 'monday',
    checked: 0,
    openTime: null,
    closeTime: null,
    isInitial: true,
  },
  {
    openDay: 'tuesday',
    checked: 0,
    openTime: null,
    closeTime: null,
    isInitial: true,
  },
  {
    openDay: 'wednesday',
    checked: 0,
    openTime: null,
    closeTime: null,
    isInitial: true,
  },
  {
    openDay: 'thursday',
    checked: 0,
    openTime: null,
    closeTime: null,
    isInitial: true,
  },
  {
    openDay: 'friday',
    checked: 0,
    openTime: null,
    closeTime: null,
    isInitial: true,
  },
  {
    openDay: 'saturday',
    checked: 0,
    openTime: null,
    closeTime: null,
    isInitial: true,
  },
  {
    openDay: 'sunday',
    checked: 0,
    openTime: null,
    closeTime: null,
    isInitial: true,
  },
]
